import React from "react";

import type { FeedItem } from "@app/analytics/Home/types";

import ActionItem from "./ActionItem";
import BaseHomeFeedItemLayout from "./BaseHomeFeedItemLayout";
import KeyQuestionAnswerItem from "./KeyQuestionAnswerItem";
import KeyQuestionItem from "./KeyQuestionItem";
import MeetingReportErrorItem from "./MeetingReportErrorItem";
import MeetingReportItem from "./MeetingReportItem";

type HomeFeedItemProps = FeedItem & {
  onClick: (id: string) => void;
};

/**
 * HomeFeedItem will look at the item type and render the corresponding component for that type
 */
const HomeFeedItem = (props: HomeFeedItemProps) => {
  switch (props.type) {
    case "meeting_report":
      return <MeetingReportItem {...props} />;
    case "meeting_report_error":
      return <MeetingReportErrorItem {...props} />;
    case "action_item":
      return <ActionItem {...props} />;
    case "key_question":
      return <KeyQuestionItem {...props} />;
    case "key_question_answer":
      return <KeyQuestionAnswerItem {...props} />;
    default:
      return <BaseHomeFeedItemLayout {...props} />;
  }
};

export default HomeFeedItem;
